<script>
    export let item
    export let status
    export let active
    export let connector

    $: if(active) {
        // console.log('loading redo')
    } else {
        // console.log('unloading redo')
    }

</script>
<h4 class="ui header">Refazer</h4>
<div class="ui segment">
    <button class="ui blue button">Confirmar</button>
</div>

